// extracted by mini-css-extract-plugin
module.exports = {"agreement":"Agreement_agreement__w5hBL","accent":"Agreement_accent__H_HO1"};